// @flow
import PagePartenaireHeader from 'components/page/PagePartenaireHeader';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/page/PagePartenaireHeader';
import { withRouter } from 'react-router-dom';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      title: state.partenaireState.partenaire.title,
      slug_parent: state.pageListState.slug,
      titleParent: state.pageListState.title,
      featured_media: state.pageListState.featured_media,
      meta_description: state.partenaireState.partenaire.meta_description,
      meta_title: state.partenaireState.partenaire.meta_title,
      banniere: state.settingsState.banniere,
      filarianne: state.partenaireState.partenaire.filarianne,
    })
  )(PagePartenaireHeader)
);
